import React, { useState } from "react";

import {
    lighten,
    MenuItem,
    Select,
    SelectProps,
    styled,
    useTheme
} from "@mui/material";
import KeyboardArrowDownOutlinedIcon from "@mui/icons-material/KeyboardArrowDownOutlined";
import { Controller, FieldPath } from "react-hook-form";
import { SearchOptions } from "./options/options";
import { SearchOptionsLabels } from "./texts/options";
import shadows from "@mui/material/styles/shadows";
import { SearchFieldLabel } from "../components/label";

type SearchSelectProps = {
    name: FieldPath<SearchFormInputs>;
    label: string;
    values?: (string | number)[];
    className?: string;
};

const MySelect = styled(Select)<SelectProps>(({ theme }) => ({
    borderRadius: 8,
    width: "100%",
    "& .MuiSelect-select": {
        padding: "10px 0px 10px 16px",

        borderWidth: 3,
        fontSize: "1rem",
        "&:focus": {
            shadows: shadows[1]
        }
    },
    "& .MuiOutlinedInput-notchedOutline": {
        borderColor: theme.palette.grey[300]
    },
    "&:hover .MuiOutlinedInput-notchedOutline": {
        borderColor: theme.palette.grey[300],
        boxShadow:
            "0px 1px 2px 0px rgba(16, 24, 40, 0.05), 0px 0px 0px 4px #FCF1F3;"
    },
    "&.Mui-focused .MuiOutlinedInput-notchedOutline": {
        borderColor: theme.palette.primary.light
    },
    "& .MuiMenuItem-root": {
        fontSize: "2rem"
    }
}));

export const SearchSelect = ({
    name,
    label,
    values,
    className
}: SearchSelectProps) => {
    const theme = useTheme();
    const [options] = useState(() => {
        const selectValues = values ?? [0, ...SearchOptions[name]];
        const optionLabels = SearchOptionsLabels[name] || {};
        return selectValues.map((value) => (
            <MenuItem
                key={value}
                value={value}
                sx={{
                    "&:hover": {
                        backgroundColor: lighten(
                            theme.palette.primary.main,
                            0.92
                        )
                    },
                    "&:focus": {
                        backgroundColor: lighten(
                            theme.palette.primary.main,
                            0.92
                        )
                    },
                    "&.Mui-selected": {
                        backgroundColor: lighten(
                            theme.palette.primary.main,
                            0.77
                        )
                    }
                }}
            >
                {optionLabels[value] ||
                    (!value ? "I don't care" : `TODO ${value}`)}
            </MenuItem>
        ));
    });
    return (
        <Controller<SearchFormInputs>
            name={name}
            defaultValue={0}
            render={({ field: { onChange, value } }) => (
                <div className={`w-full ${className}`}>
                    <SearchFieldLabel name={name}>{label}</SearchFieldLabel>
                    <MySelect
                        IconComponent={KeyboardArrowDownOutlinedIcon}
                        size="medium"
                        onChange={onChange}
                        value={value}
                    >
                        {options}
                    </MySelect>
                </div>
            )}
        />
    );
};
